module.exports = __webpack_public_path__ + "static/media/dindle1.9dc5b8a8.png";